export function agentQAProgressRenderer(params: { data?: any }) {
  if (!params.data) {
    return '';
  }

  const { pass = 0, fail = 0, total = 0, percentage = 0 } = params.data;

  if (total === 0) {
    return '<div style="color: #999;">No items</div>';
  }

  // Build compact progress display with colored indicators
  return `
    <div style="display: flex; align-items: center; gap: 8px;">
      <span style="color: #4caf50; font-weight: 500;" title="Passed">${pass}</span>
      <span style="color: #666;">/</span>
      <span style="color: #f44336; font-weight: 500;" title="Failed">${fail}</span>
      <span style="color: #666;">/</span>
      <span style="color: #333;" title="Total">${total}</span>
      <span style="color: #666; margin-left: 4px;">(${percentage}%)</span>
    </div>
  `;
}
